module.exports = __webpack_public_path__ + "static/media/process-efficiency.ace5256d.svg";